// extracted by mini-css-extract-plugin
export default {"wrap":"OrdersCalendarModal_wrap__Ianjr","reactCalendar":"OrdersCalendarModal_reactCalendar__Rdtsd"};